// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"10a0842d","703":"e5b782f5","787":"fb4ccaeb"}[chunkId] + ".chunk.js";
};